import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const EastIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5 9 C 2.789062 9 1 7.207031 1 5 C 1 2.789062 2.789062 1 5 1 C 7.210938 1 9 2.789062 9 5 C 9 7.207031 7.210938 9 5 9 Z M 5 9" />
            <path
                d="M 7.335938 8.246094 C 6.738281 8.679688 6.03125 8.933594 5.292969 8.988281 C 4.558594 9.042969 3.820312 8.894531 3.164062 8.554688 C 2.507812 8.214844 1.960938 7.703125 1.578125 7.070312 C 1.195312 6.441406 0.996094 5.714844 1 4.976562 C 1.003906 4.238281 1.210938 3.515625 1.601562 2.890625 C 1.992188 2.261719 2.546875 1.757812 3.207031 1.425781 C 3.863281 1.09375 4.601562 0.953125 5.339844 1.015625 C 6.074219 1.078125 6.777344 1.339844 7.371094 1.777344 L 5 5 Z M 7.335938 8.246094"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const EastIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5 9 C 2.789062 9 1 7.207031 1 5 C 1 2.789062 2.789062 1 5 1 C 7.210938 1 9 2.789062 9 5 C 9 7.207031 7.210938 9 5 9 Z M 5 9" />
            <path
                d="M 7.335938 8.246094 C 6.738281 8.679688 6.03125 8.933594 5.292969 8.988281 C 4.558594 9.042969 3.820312 8.894531 3.164062 8.554688 C 2.507812 8.214844 1.960938 7.703125 1.578125 7.070312 C 1.195312 6.441406 0.996094 5.714844 1 4.976562 C 1.003906 4.238281 1.210938 3.515625 1.601562 2.890625 C 1.992188 2.261719 2.546875 1.757812 3.207031 1.425781 C 3.863281 1.09375 4.601562 0.953125 5.339844 1.015625 C 6.074219 1.078125 6.777344 1.339844 7.371094 1.777344 L 5 5 Z M 7.335938 8.246094"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
